import { render, staticRenderFns } from "./product-detail.vue?vue&type=template&id=267772cc&scoped=true&"
import script from "./product-detail.vue?vue&type=script&lang=ts&"
export * from "./product-detail.vue?vue&type=script&lang=ts&"
import style0 from "./product-detail.vue?vue&type=style&index=0&id=267772cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267772cc",
  null
  
)

export default component.exports